function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47 72.19L55.86 81c.48.48 1.36 7.46.88 8L55 90.72a1.24 1.24 0 01-1.76 0l-.92-.92-7-7c-2.85-2.85-5.75-5.71-7.11-7.11l-.88-.88a1.24 1.24 0 010-1.76L39 71.26c.52-.48 7.5.44 8 .93z",
  fill: "#d8dbdb"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.28 40.16a2.42 2.42 0 102.41 2.42 2.44 2.44 0 00-2.41-2.42zm7.47 2.64a2.42 2.42 0 102.41 2.42 2.44 2.44 0 00-2.41-2.42zm27.45 27a2.42 2.42 0 10-2.42 2.42 2.41 2.41 0 002.42-2.41zm.22 5.06a2.42 2.42 0 102.41 2.41 2.43 2.43 0 00-2.41-2.4z",
  fill: "#676767"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.78 49.56l8.7 8.7C79.45 59.23 89 86 88.05 87l-3.47 3.47a2.45 2.45 0 01-3.47 0L61.92 66 37.58 46.93a2.45 2.45 0 010-3.47L41.05 40c.95-1 27.76 8.6 28.73 9.56z",
  fill: "#d8dbdb"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.1 36c2.41 2.41.26 8.43-2.6 11.33L58.1 78.64c-2.9 2.9-13.27 9.4-15.68 7S46.5 72.85 49.4 70l31.36-31.46c2.9-2.9 8.92-5.01 11.34-2.54z",
  fill: "#e4e7e7"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.55 72.05l31.37-31.36c2.45-2.46 7.15-4.35 10-3.42a4 4 0 00-.79-1.37c-2.42-2.41-8.44-.26-11.34 2.64L49.4 69.9c-2.9 2.9-9.36 13.27-7 15.68a2.26 2.26 0 001.62.53c.07-3.78 5.07-11.6 7.53-14.06z",
  fill: "#dde0e0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.26 58.44l5 3.86 12.65-12.69-.13-.13a45.72 45.72 0 00-6.06-2.55z",
  fill: "#c7caca"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.78 71l15.29 19.42a2.48 2.48 0 003.25.17l-16.87-21.3zm-7-10.37L37.32 43.81a2.46 2.46 0 00.26 3.12l19.51 15.29z",
  fill: "#3db39e"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.09 62.22l1.67-1.63-4.84-3.78-1.66 1.63z",
  fill: "#38a592"
});

var SvgIcShipping = function SvgIcShipping(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcShipping as ReactComponent };